// Страны документов: ISO 3166-1 alpha-3 и русское название.
export const COUNTRIES = [
  { code: "AZE", name: "Азербайджан" },
  { code: "ALB", name: "Албания" },
  { code: "DZA", name: "Алжир" },
  { code: "AGO", name: "Ангола" },
  { code: "AND", name: "Андорра" },
  { code: "ATG", name: "Антигуа и Барбуда" },
  { code: "USA", name: "США" },
  { code: "ARG", name: "Аргентина" },
  { code: "ARM", name: "Армения" },
  { code: "AUS", name: "Австралия" },
  { code: "AUT", name: "Австрия" },
  { code: "AFG", name: "Афганистан" },

  { code: "BHS", name: "Багамы" },
  { code: "BHR", name: "Бахрейн" },
  { code: "BGD", name: "Бангладеш" },
  { code: "BRB", name: "Барбадос" },
  { code: "BLR", name: "Беларусь" },
  { code: "BLZ", name: "Белиз" },
  { code: "BEL", name: "Бельгия" },
  { code: "BEN", name: "Бенин" },
  { code: "BGR", name: "Болгария" },
  { code: "BOL", name: "Боливия" },
  { code: "BIH", name: "Босния и Герцеговина" },
  { code: "BWA", name: "Ботсвана" },
  { code: "BRA", name: "Бразилия" },
  { code: "BRN", name: "Бруней" },
  { code: "BFA", name: "Буркина-Фасо" },
  { code: "BDI", name: "Бурundi" },
  { code: "BTN", name: "Бутан" },

  { code: "VUT", name: "Вануату" },
  { code: "VAT", name: "Ватикан" },
  { code: "GBR", name: "Великобритания" },
  { code: "HUN", name: "Венгрия" },
  { code: "VEN", name: "Венесуэла" },
  { code: "VNM", name: "Вьетнам" },

  { code: "GAB", name: "Габон" },
  { code: "HTI", name: "Гаити" },
  { code: "GUY", name: "Гайана" },
  { code: "GMB", name: "Гамбия" },
  { code: "GHA", name: "Гана" },
  { code: "GTM", name: "Гватемала" },
  { code: "GIN", name: "Гвинея" },
  { code: "GNB", name: "Гвинея-Бисау" },
  { code: "DEU", name: "Германия" },
  { code: "HND", name: "Гондурас" },
  { code: "GRD", name: "Гренада" },
  { code: "GEO", name: "Грузия" },
  { code: "GRC", name: "Греция" },

  { code: "DNK", name: "Дания" },
  { code: "DJI", name: "Джибути" },
  { code: "DMA", name: "Доминика" },
  { code: "DOM", name: "Доминиканская Республика" },
  { code: "COD", name: "Демократическая Республика Конго" },

  { code: "EGY", name: "Египет" },

  { code: "ZMB", name: "Замбия" },
  { code: "ZWE", name: "Зимбабве" },

  { code: "ISR", name: "Израиль" },
  { code: "IND", name: "Индия" },
  { code: "IDN", name: "Индонезия" },
  { code: "JOR", name: "Иордания" },
  { code: "IRQ", name: "Ирак" },
  { code: "IRN", name: "Иран" },
  { code: "IRL", name: "Ирландия" },
  { code: "ISL", name: "Исландия" },
  { code: "ESP", name: "Испания" },
  { code: "ITA", name: "Италия" },

  { code: "YEM", name: "Йемен" },

  { code: "CPV", name: "Кабо-Верде" },
  { code: "KAZ", name: "Казахстан" },
  { code: "KHM", name: "Камбоджа" },
  { code: "CMR", name: "Камерун" },
  { code: "CAN", name: "Канада" },
  { code: "QAT", name: "Катар" },
  { code: "KEN", name: "Кения" },
  { code: "CYP", name: "Кипр" },
  { code: "KGZ", name: "Кыргызстан" },
  { code: "KIR", name: "Кирибати" },
  { code: "CHN", name: "Китай" },
  { code: "COL", name: "Колумбия" },
  { code: "COM", name: "Коморы" },
  { code: "COG", name: "Республика Конго" },
  { code: "CRI", name: "Коста-Рика" },
  { code: "CIV", name: "Кот-д'Ивуар" },
  { code: "CUB", name: "Куба" },
  { code: "KWT", name: "Кувейт" },
  { code: "PRK", name: "Северная Корея" },
  { code: "KOR", name: "Южная Корея" },

  { code: "LAO", name: "Лаос" },
  { code: "LVA", name: "Латвия" },
  { code: "LSO", name: "Лесото" },
  { code: "LBR", name: "Либерия" },
  { code: "LBN", name: "Ливан" },
  { code: "LBY", name: "Ливия" },
  { code: "LTU", name: "Литва" },
  { code: "LIE", name: "Лихтенштейн" },
  { code: "LUX", name: "Люксембург" },

  { code: "MUS", name: "Маврикий" },
  { code: "MRT", name: "Мавритания" },
  { code: "MDG", name: "Мадагаскар" },
  { code: "MKD", name: "Северная Македония" },
  { code: "MWI", name: "Малави" },
  { code: "MYS", name: "Малайзия" },
  { code: "MLI", name: "Мали" },
  { code: "MDV", name: "Мальдивы" },
  { code: "MLT", name: "Мальта" },
  { code: "MAR", name: "Марокко" },
  { code: "MHL", name: "Маршалловы Острова" },
  { code: "MEX", name: "Мексика" },
  { code: "FSM", name: "Микронезия" },
  { code: "MOZ", name: "Мозамбик" },
  { code: "MDA", name: "Молдова" },
  { code: "MCO", name: "Монако" },
  { code: "MNG", name: "Монголия" },
  { code: "MMR", name: "Мьянма" },

  { code: "NAM", name: "Намибия" },
  { code: "NRU", name: "Науру" },
  { code: "NPL", name: "Непал" },
  { code: "NER", name: "Нигер" },
  { code: "NGA", name: "Нигерия" },
  { code: "NLD", name: "Нидерланды" },
  { code: "NIC", name: "Никарагуа" },
  { code: "NZL", name: "Новая Зеландия" },
  { code: "NOR", name: "Норвегия" },

  { code: "ARE", name: "ОАЭ" },
  { code: "OMN", name: "Оман" },

  { code: "PAK", name: "Пакистан" },
  { code: "PLW", name: "Палау" },
  { code: "PSE", name: "Палестина" },
  { code: "PAN", name: "Панама" },
  { code: "PNG", name: "Папуа — Новая Гвинея" },
  { code: "PRY", name: "Парагвай" },
  { code: "PER", name: "Перу" },
  { code: "POL", name: "Польша" },
  { code: "PRT", name: "Португалия" },

  { code: "RUS", name: "Россия" },
  { code: "RWA", name: "Руанда" },
  { code: "ROU", name: "Румыния" },

  { code: "SLV", name: "Сальвадор" },
  { code: "WSM", name: "Самоа" },
  { code: "SMR", name: "Сан-Марино" },
  { code: "STP", name: "Сан-Томе и Принсипи" },
  { code: "SAU", name: "Саудовская Аравия" },
  { code: "SWZ", name: "Эсватини" },
  { code: "SYC", name: "Сейшелы" },
  { code: "SEN", name: "Сенегал" },
  { code: "VCT", name: "Сент-Винсент и Гренадины" },
  { code: "KNA", name: "Сент-Китс и Невис" },
  { code: "LCA", name: "Сент-Люсия" },
  { code: "SRB", name: "Сербия" },
  { code: "SGP", name: "Сингапур" },
  { code: "SYR", name: "Сирия" },
  { code: "SVK", name: "Словакия" },
  { code: "SVN", name: "Словения" },
  { code: "SLB", name: "Соломоновы Острова" },
  { code: "SOM", name: "Сомали" },
  { code: "SDN", name: "Судан" },
  { code: "SUR", name: "Суринам" },
  { code: "SLE", name: "Сьерра-Леоне" },

  { code: "TJK", name: "Таджикистан" },
  { code: "THA", name: "Таиланд" },
  { code: "TZA", name: "Танзания" },
  { code: "TGO", name: "Того" },
  { code: "TON", name: "Тонга" },
  { code: "TTO", name: "Тринидад и Тобаго" },
  { code: "TUV", name: "Тувалу" },
  { code: "TUN", name: "Тунис" },
  { code: "TKM", name: "Туркменистан" },
  { code: "TUR", name: "Турция" },

  { code: "UGA", name: "Уганда" },
  { code: "UZB", name: "Узбекистан" },
  { code: "UKR", name: "Украина" },
  { code: "URY", name: "Уругвай" },

  { code: "FJI", name: "Фиджи" },
  { code: "PHL", name: "Филиппины" },
  { code: "FIN", name: "Финляндия" },
  { code: "FRA", name: "Франция" },

  { code: "HRV", name: "Хорватия" },

  { code: "CAF", name: "Центральноафриканская Республика" },
  { code: "TCD", name: "Чад" },
  { code: "MNE", name: "Черногория" },
  { code: "CZE", name: "Чехия" },
  { code: "CHL", name: "Чили" },

  { code: "CHE", name: "Швейцария" },
  { code: "SWE", name: "Швеция" },
  { code: "LKA", name: "Шри-Ланка" },

  { code: "ECU", name: "Эквадор" },
  { code: "GNQ", name: "Экваториальная Гвинея" },
  { code: "ERI", name: "Эритрея" },
  { code: "EST", name: "Эстония" },
  { code: "ETH", name: "Эфиопия" },

  { code: "ZAF", name: "ЮАР" },
  { code: "SSD", name: "Южный Судан" },

  { code: "JAM", name: "Ямайка" },
  { code: "JPN", name: "Япония" },
].sort((a, b) => a.name.localeCompare(b.name, "ru"));

const BY_CODE = Object.fromEntries(COUNTRIES.map((c) => [c.code, c.name]));

export const countryName = (code) => BY_CODE[code] || code;
